import { useSelector, useDispatch } from 'react-redux'
import { useContext, useState, useCallback } from 'react'
import { fetchInitialLoad } from '../features/owners/fetchInitialLoad'
import { viewContext } from '../context/viewContext'

export const useFetchInitialLoad = ({ page, per_page, thread_id }) => {
  const { unique_owner_id } = useContext(viewContext)
  const dispatch = useDispatch()

  const owner = useSelector((state) => state.owners[unique_owner_id])

  const status = owner?.actionStatuses?.fetchInitialLoad?.status
  const loaded = owner?.actionStatuses?.fetchInitialLoad?.loaded

  const isFetching = status === 'fetching'
  const isLoading = status === 'fetching' && !loaded
  const isSuccess = status === 'success'
  const error = status === 'failed'

  const fetch = useCallback(async () => {
    await dispatch(fetchInitialLoad({ unique_owner_id, page, per_page, thread_id }))
  }, [unique_owner_id, page, per_page, thread_id, dispatch])

  return {
    isFetching,
    isLoading,
    isSuccess,
    error,
    fetch,
  }
}
